import prototype from "../../../../docs/prototypes/employees-full-flow.html?raw";
import { step10Text } from "./staff-step10-language";

// Read the approved dictionary as data, never execute the prototype's scripts.
const dictionary:Record<string,string>={};
for(const match of prototype.matchAll(/"((?:[^"\\]|\\.)*)"\s*:\s*"((?:[^"\\]|\\.)*)"/g)){
  try {
    const key=JSON.parse(`"${match[1]}"`),value=JSON.parse(`"${match[2]}"`);
    if(/[\u0600-\u06ff]/.test(value))dictionary[key]=value;
  }catch{/* Non-dictionary script strings are not translations. */}
}
// v83's runtime date tokenizer uses unquoted shorthand month keys (Aug, Nov).
const months=prototype.match(/const MON=\{([^}]+)\}/)?.[1]||"";
for(const match of months.matchAll(/(\w+):"([^"]+)"/g))dictionary[match[1]]=match[2];
// These recovery labels are live-server behavior, not part of the static demo.
Object.assign(dictionary,{
  "1 deduction":"خصم واحد",
  "Review current rate":"مراجعة السعر الحالي",
  "Could not refresh pay rates. Retry.":"تعذر تحديث أسعار الرواتب. أعد المحاولة.",
  "Details · required":"التفاصيل · مطلوب",
});
const aliases:Record<string,string>={"Stop offering":"Stop hiring for it","Offer again":"Hire for it again","Offered":"Hiring","Not offered":"Not hiring"};
const templates=Object.entries(dictionary).filter(([key])=>/\{\d+\}/.test(key)&&key.replace(/\{\d+\}/g,"").length>3)
  .sort(([a],[b])=>b.replace(/\{\d+\}/g,"").length-a.replace(/\{\d+\}/g,"").length)
  .map(([key,translation])=>({
    translation,
    pattern:new RegExp(`^${key.split(/\{\d+\}/).map(p=>p.replace(/[.*+?^${}()|[\]\\]/g,"\\$&")).join("(.+?)")}$`),
  }));
export function step11Text(value:string,rtl:boolean):string{
  value=aliases[value]||value.replace(/stop offering it/g,"stop hiring for it");
  if(!rtl)return value;
  if(dictionary[value])return dictionary[value];
  for(const {pattern,translation} of templates){
    const match=value.match(pattern);
    if(match)return translation.replace(/\{(\d+)\}/g,(_,n)=>step11Text(match[Number(n)+1]||"",rtl));
  }
  return step10Text(value,rtl);
}
